import { all, call } from 'redux-saga/effects';

import watchAnalytics from './analytics/sagas';
import watchAPI from './api/sagas';
import watchAuth from './auth/sagas';
import watchBigScreen from './bigScreen/sagas';
import watchDeepLink from './deepLink/sagas';
import watchGuides from './guides/sagas';
import watchNotifications from './notifications/sagas';
import watchPersonalPlan from './personalPlan/sagas';
import watchSubscriptions from './subscriptions/sagas';
import watchUser from './user/sagas';

export default function* rootSaga() {
    yield all([
        call(watchUser),
        call(watchDeepLink),
        call(watchAuth),
        call(watchNotifications),
        call(watchSubscriptions),
        call(watchGuides),
        call(watchPersonalPlan),
        call(watchBigScreen),
        call(watchAPI),
        call(watchAnalytics),
    ]);
}
